import { AlarmClock, BadgeCheck, CircleX, Minus } from 'lucide-react'

import DisplayTooltipOnHover from 'components/reusable/DisplayTooltipOnHover'
import { Badge } from 'slab'
import { AdminEmployerPlaidAccountVerificationStatus } from 'utils/web_api.schemas'

interface PlaidAccountVerificationStatusBadgeProps {
  status: AdminEmployerPlaidAccountVerificationStatus
}

const getIcon = (status: AdminEmployerPlaidAccountVerificationStatus) => {
  if (status === AdminEmployerPlaidAccountVerificationStatus.verified) {
    return BadgeCheck
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.failed) {
    return CircleX
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.pending) {
    return AlarmClock
  } else {
    return Minus
  }
}

const getBadgeType = (status: AdminEmployerPlaidAccountVerificationStatus): 'success' | 'neutral' | 'critical' => {
  if (status === AdminEmployerPlaidAccountVerificationStatus.verified) {
    return 'success'
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.failed) {
    return 'critical'
  } else {
    return 'neutral'
  }
}

const getHoverDescription = (status: AdminEmployerPlaidAccountVerificationStatus) => {
  if (status === AdminEmployerPlaidAccountVerificationStatus.verified) {
    return 'Bank account is verified and ready for use.'
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.failed) {
    return 'Bank account verification has failed or needs to be reauthenticated.'
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.pending) {
    return 'Bank account linking has been initiated but is not yet complete.'
  } else {
    return 'No bank account connected.'
  }
}

const getDisplayText = (status: AdminEmployerPlaidAccountVerificationStatus) => {
  if (status === AdminEmployerPlaidAccountVerificationStatus.verified) {
    return 'Verified'
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.failed) {
    return 'Failed'
  } else if (status === AdminEmployerPlaidAccountVerificationStatus.pending) {
    return 'Pending'
  } else {
    return 'None'
  }
}

const PlaidAccountVerificationStatusBadge = ({ status }: PlaidAccountVerificationStatusBadgeProps) => {
  if (status === AdminEmployerPlaidAccountVerificationStatus.none) {
    return <span className='text-gray-400 font-light'>&mdash;</span>
  }

  return (
    <DisplayTooltipOnHover text={getHoverDescription(status)}>
      <Badge
        type={getBadgeType(status)}
        leftIcon={getIcon(status)}
        title={getHoverDescription(status)}
      >
        {getDisplayText(status)}
      </Badge>
    </DisplayTooltipOnHover>
  )
}

export default PlaidAccountVerificationStatusBadge
